import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'largeNumberFormat',
})
export class LargeNumberFormatPipe implements PipeTransform {
  transform(value: any) {
    if (value >= 1e30) {
      return Math.round(value / 1e30) + ' No'; // Nonillion
    } else if (value >= 1e27) {
      return Math.round(value / 1e27) + ' Oc'; // Octillion
    } else if (value >= 1e24) {
      return Math.round(value / 1e24) + ' Sp'; // Septillion
    } else if (value >= 1e21) {
      return Math.round(value / 1e21) + ' Sx'; // Sextillion
    } else if (value >= 1e18) {
      return Math.round(value / 1e18) + ' Qi'; // Quintillion
    } else if (value >= 1e15) {
      return Math.round(value / 1e15) + ' Qd'; // Quadrillion
    } else if (value >= 1e13) {
      return Math.round(value / 1e13) + ' T'; // Trillion
    } else if (value >= 1e9) {
      return Math.round(value / 1e9).toFixed(2) + ' B'; // B for Billion
    } else if (value >= 1e7) {
      return Math.round(value / 1e7).toFixed(2) + ' Cr'; // Cr for Crore
    } else if (value >= 1e6) {
      return Math.round(value / 1e6).toFixed(2) + ' M'; // M for Million
    } else if (value >= 1e5) {
      return Math.round(value / 1e5).toFixed(2) + ' L'; // L for Lakh
    } else if (value >= 1e3) {
      return Math.round(value / 1e3).toFixed(2) + ' K'; // K for Thousand
    } else {
      return value.toString(); // For values less than 1000
    }
  }
}
